import {
  getIconFromType,
  getWidgetProps,
  InputMarginContainer,
  RichTextAdvancedRender,
  useWidgetEnabled,
  useWidgetVisibility,
  type IWidgetComponentProps,
} from '@framework/engine';
import { useHandleSubmit } from '@framework/form';
import { AlignRow } from '@framework/ui';
import { Button } from 'antd';
import { CandidateWidgetContainer } from '../candidate/CandidateWidgetContainer';
import { useVoteWidgetSubmitForm } from './form/useVoteWidgetSubmitForm';
import { VoteSuccessResult } from './VoteSuccessResult';
import { type IVoteWidget } from './IVoteWidget';

export interface IVoteWidgetComponentProps
  extends IWidgetComponentProps<IVoteWidget> {}

/**
 * Componente per il widget di voto.
 */
export function VoteWidgetComponent(props: IVoteWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);
  const enabled = useWidgetEnabled(widget, options);

  const { onSubmit: onValid, isSucceeded, loading } = useVoteWidgetSubmitForm();

  const handleSubmit = useHandleSubmit({ onValid, touchFields: true });

  if (!visible) return null;

  if (props.readonly) return null;

  if (isSucceeded) {
    return <VoteSuccessResult />;
  }

  return (
    <CandidateWidgetContainer
      panelTitle={widget.panelTitle}
      showPanel={widget.showPanel}
    >
      <InputMarginContainer>
        <AlignRow justify={widget.layout?.buttonAlign ?? 'flex-end'}>
          <Button
            size="large"
            block
            type={widget.layout?.buttonType ?? 'primary'}
            icon={getIconFromType(widget.layout?.iconType)}
            disabled={enabled === false}
            loading={loading}
            onClick={handleSubmit}
          >
            <RichTextAdvancedRender inline text={widget.label} />
          </Button>
        </AlignRow>
      </InputMarginContainer>
    </CandidateWidgetContainer>
  );
}
